var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrintables(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.564,
    height: 41.907,
    viewBox: "0 0 39.564 41.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-paper-2199079-FFFFFF",
    d: "M360.446,267.48a1.2,1.2,0,0,0-1.321,1.038v3.623h-7.186a1.2,1.2,0,0,0-1.321,1.037v33.173a1.2,1.2,0,0,0,1.321,1.037h26.417a1.2,1.2,0,0,0,1.321-1.037v-3.624h7.185a1.2,1.2,0,0,0,1.321-1.037V268.518a1.2,1.2,0,0,0-1.321-1.038Zm8.662,4.661h-7.341v-2.586H385.54v31.1h-5.864s0-20.258,0-20.261m-26.413-6.178h14.532v6.217a1.2,1.2,0,0,0,1.321,1.037h7.92v23.845H353.26Zm17.167,1.462,4.738,3.719h-4.734Z",
    transform: "translate(-349.618 -266.48)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrintables);
export default __webpack_public_path__ + "static/media/icon_printables.1ceef025d3948eaadb7db39c0d041b33.svg";
export { ForwardRef as ReactComponent };